import { render, staticRenderFns } from "./SectionWhyWorth.vue?vue&type=template&id=29d9175e&"
import script from "./SectionWhyWorth.vue?vue&type=script&lang=js&"
export * from "./SectionWhyWorth.vue?vue&type=script&lang=js&"
import style0 from "./SectionWhyWorth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports